module.exports = __webpack_public_path__ + "static/media/John5.56335896.png";